/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Billing_MonthlyInputs */



/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Signup_Billing_MonthlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_billing_monthly = /** @type {((inputs?: Signup_Billing_MonthlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Billing_MonthlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mensuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Monatlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mensile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ежемесячно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mensual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("月度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("毎月")
	if (locale === "hi") return /** @type {LocalizedString} */ ("महीने के")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mensal")
	return /** @type {LocalizedString} */ ("Monthly")
});